import React, { useState, useEffect } from 'react'

import DropDownMenu from '../DropDownMenu/DropDownMenu'
import TextButton from '../TextButton/TextButton'
import BurgerMenu from '../BurgerMenu/BurgerMenu'
import Logo from '../Logo/Logo'

import {
	StyledHeaderMinContainer,
	StyledRightContainer,
	StyledLeftContainer,
	StyledFixedContainer,
	StyledRightContainerResponsive,
	StyledRightContainerInner,
	StyledSignIn
} from './MainHeaderStyle'
import DocsDropDown from '../DropDownMenu/DocsDropDown'

const MainHeader = ({ darkColor, eSignature }) => {
	const [headerBackground, setHeaderBackground] = useState(false)

	if (typeof window !== 'undefined') {
		let prevScrollpos = window.pageYOffset
		window.onscroll = function () {
			var currentScrollPos = window.pageYOffset
			let navbarStyle = document.getElementById('navbar')
			if (navbarStyle) {
				if (Math.abs(prevScrollpos) > Math.abs(currentScrollPos)) {
					document.getElementById('navbar').style.top = '0'
				} else if (Math.abs(prevScrollpos) < Math.abs(currentScrollPos) && Math.abs(currentScrollPos) > 40) {
					document.getElementById('navbar').style.top = '-88px'
				}
				prevScrollpos = currentScrollPos
			}
		}
	}

	useEffect(() => {
		window.addEventListener('scroll', handleScroll)
		// return window.removeEventListener('scroll', handleScroll)
	}, [])

	const handleScroll = () => {
		let scrollPos = window.scrollY
		if (window.pageYOffset > 0 && scrollPos) {
			setHeaderBackground(true)
		} else {
			setHeaderBackground(false)
		}
	}

	return (
		<StyledFixedContainer id='navbar' headerBackground={headerBackground}>
			<StyledHeaderMinContainer id='headerMin'>
				<StyledLeftContainer>
					<Logo />
				</StyledLeftContainer>
				<StyledRightContainer>
					<StyledRightContainerResponsive>
						{/* <StyledSignIn>
							<TextButton
								value='signIn'
								as='a'
								hrefValue={'https://admin.kvalifika.ge'}
								darkColor={darkColor}
							/>
						</StyledSignIn> */}
						<BurgerMenu />
					</StyledRightContainerResponsive>
					
					<StyledRightContainerInner>
						<DropDownMenu headerBackground={headerBackground} darkColor={darkColor} />
						{/* {!eSignature && (
							<TextButton
								headerBackground={headerBackground}
								value='pricing'
								hrefValue={`/pricing`}
								darkColor={darkColor}
							/>
						)} */}
						{!eSignature && <DocsDropDown headerBackground={headerBackground} darkColor={darkColor} />}
						<TextButton headerBackground={headerBackground} value='About Us' hrefValue='/about-us' darkColor={darkColor} />
						<TextButton headerBackground={headerBackground} value='blog' hrefValue='/blog' darkColor={darkColor} />
						{/* {!eSignature && (
							<TextButton
								headerBackground={headerBackground}
								value='signIn'
								as='a'
								hrefValue={'https://admin.kvalifika.ge'}
								darkColor={darkColor}
							/>
						)} */}
						{/* {!eSignature && (
							<TextButton
								headerBackground={headerBackground}
								value='signUp'
								as='a'
								hrefValue={'https://admin.kvalifika.ge/signup'}
								darkColor={darkColor}
							/>
						)} */}
						<TextButton
							headerBackground={headerBackground}
							value='bookADemo'
							as='a'
							hrefValue="https://cal.com/bekat"
							darkColor={darkColor}
						/>
					</StyledRightContainerInner>
				</StyledRightContainer>
			</StyledHeaderMinContainer>
		</StyledFixedContainer>
	)
}

export default MainHeader
